/* eslint-disable prettier/prettier */
import { AntDesign } from "@expo/vector-icons";
import { BlurView } from "expo-blur";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { View, Modal, Pressable, Text } from "react-native";

import {
  CreateCryptoAddressToFiat,
  RenderCryptoDeposit,
  RenderFiatDeposit,
} from "@/components/card/utils/UtilsCardAccount";
import { checkIsBridgeApproved } from "@/utils/web3/Utils";

interface Instructions {
  [key: string]: string;
}

interface DepositModalProps {
  visible: boolean;
  accountType?: string;
  depositInstructions: Instructions[];
  accountId: string;
  onClick?: (state: boolean) => void;
  onClose: () => void;
}

export default function DepositModal(props: DepositModalProps) {
  const [selectedDeposit, setSelectedDeposit] = useState<string>("FIAT");
  const isBridgeActive = checkIsBridgeApproved();
  const { t } = useTranslation();

  const cryptoInstructions = Array.isArray(props.depositInstructions)
    ? props.depositInstructions?.find(
        (instruction) => instruction.instructionType === "CRYPTO"
      ) ?? {}
    : {};

  const handleClose = () => {
    props.onClose();
  };

  return (
    <Modal visible={props.visible} transparent animationType="fade">
      <BlurView intensity={20} className="flex-1 justify-center items-center">
        <View className="p-6 bg-white1 border border-gray rounded-lg w-full h-full items-center lg:w-104 lg:h-136 shadow">
          <Pressable className="absolute right-3 top-3" onPress={handleClose}>
            <AntDesign name="close" size={24} color="black" />
          </Pressable>
          {props.accountType !== "USD" && props.accountType !== "EUR" ? (
            <RenderCryptoDeposit
              address={cryptoInstructions?.address ?? ""}
              blockchain={cryptoInstructions?.blockchain ?? ""}
              network={cryptoInstructions?.network ?? ""}
            />
          ) : (
            <View className="w-full flex-grow">
              <View className="flex-row w-full items-center justify-center mt-6 mb-2">
                <Pressable
                  onPress={() => setSelectedDeposit("FIAT")}
                  className={`w-1/2 items-center ${
                    selectedDeposit === "FIAT"
                      ? "border-b-2 border-purple1"
                      : ""
                  }`}
                >
                  <Text className="text-lg font-light hover:text-purple1">
                    {t("common:terms.fiat")}
                  </Text>
                </Pressable>
                <Pressable
                  onPress={() => setSelectedDeposit("CRYPTO")}
                  className={`w-1/2 items-center ${
                    selectedDeposit === "CRYPTO"
                      ? "border-b-2 border-purple1"
                      : ""
                  }`}
                  disabled={!isBridgeActive}
                >
                  <View className="flex-row items-center gap-1">
                    <Text className="text-lg font-light hover:text-purple1">
                      {t("common:terms.crypto")}
                    </Text>
                    {!isBridgeActive && (
                      <AntDesign
                        name="lock"
                        size={20}
                        className="text-black1"
                      />
                    )}
                  </View>
                </Pressable>
              </View>
              {selectedDeposit === "CRYPTO" ? (
                <CreateCryptoAddressToFiat
                  accountId={props.accountId}
                  onError={props.onClose}
                />
              ) : (
                <RenderFiatDeposit
                  depositInstructions={props.depositInstructions}
                />
              )}
            </View>
          )}
        </View>
      </BlurView>
    </Modal>
  );
}
